/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedOrderEditRequest } from '../types/PatchedOrderEdit';
import type { OrderEditResponse } from '../types/OrderEdit';

export type OrdersPartialUpdateRequest = PatchedOrderEditRequest;
export type OrdersPartialUpdateResponse = OrderEditResponse;

export type OrdersPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/orders/{id}/
 *
 * ```yaml
 * operationId: orders_partial_update
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderEdit'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderEdit'
 *     description: ''
 * ```
 */
export const ordersPartialUpdateOperation = ({ id, ...rest }: OrdersPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/orders/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/orders/{id}/' };
  };

/**
 * PATCH /dmx-server/orders/{id}/
 *
 * ```yaml
 * operationId: orders_partial_update
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderEdit'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderEdit'
 *     description: ''
 * ```
 */
export const ordersPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: OrdersPartialUpdateQuery;
  request: PatchedOrderEditRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrderEditResponse>> => {
  const operation = ordersPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
